// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsProfileSubtitle_container__3GXOp","title":"SettingsProfileSubtitle_title__15y6L","subTitle":"SettingsProfileSubtitle_subTitle__wULJ8"};